<template>
	<AppAvatarGroup :numToShow="numToShow" :userIds="idea.account_idea?.voters || []" />
</template>
<script>
export default { name: 'UpVotersAvatarGroup', props: { idea: { type: Object }, numToShow: { type: Number, default: 3 } } };
</script>
